// extracted by mini-css-extract-plugin
export default {"domainBindContainer":"DomainBind_domainBindContainer__d+A53","header":"DomainBind_header__B3Dj7"};